<button *ngFor="let image of images" class="images-container">
  <img [src]="image.src" [alt]="image.alt" class="image" />
</button>
